import React, { createContext } from 'react';
export const hpContext = createContext(null);
